import React, { forwardRef } from "react";
import classes from "./UserDropdown.module.css";

const UserDropdown = forwardRef(
  (
    {
      show,
      users,
      loading = false,
      highlightedIndex,
      onSelect,
    },
    ref
  ) => {
    if (!show || !users?.length) return null;

    return (
      <div ref={ref} className={classes.userDropdown}>
        {loading ? (
          <div className={classes.dropdownLoading}>Loading...</div>
        ) : (
          users.map((user, index) => (
            <div
              key={user.userDetailId}
              className={`${classes.userOption} ${
                index === highlightedIndex ? classes.highlighted : ""
              }`}
              onClick={() => onSelect(user)}
            >
             {user.playerFullName && <div className={classes.userName}>
                {user.playerFullName}
              </div>}

              <div className={classes.userPhone}>
                <span>{user.userFullName}</span>
                <span>{user.cellNumber}</span>
              </div>
            </div>
          ))
        )}
      </div>
    );
  }
);

UserDropdown.displayName = "UserDropdown";

export default UserDropdown;
